import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const STORES_API_PATH = '/api/stores';

// --- Core Store Functions ---
const getStores = async () => {
  const response = await axios.get(`${API_BASE_URL}${STORES_API_PATH}`);
  return response.data.data;
};

const getStoreById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${STORES_API_PATH}/${id}`);
  return response.data.data;
};

const createStore = async (storeData) => {
  const response = await axios.post(`${API_BASE_URL}${STORES_API_PATH}`, storeData);
  return response.data.data;
};

const updateStore = async (id, storeData) => {
  const response = await axios.put(`${API_BASE_URL}${STORES_API_PATH}/${id}`, storeData);
  return response.data.data;
};

const deleteStore = async (id) => {
  await axios.delete(`${API_BASE_URL}${STORES_API_PATH}/${id}`);
  return id;
};

// --- Nested Settings Functions ---

// Opening Hours
const updateOpeningHours = async (storeId, hoursData) => {
    const response = await axios.put(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/opening-hours`, { hours: hoursData });
    return response.data;
};

// Payment Methods
const addPaymentMethod = async (storeId, methodData) => {
  const response = await axios.post(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/payment-methods`, methodData);
  return response.data.data;
};
const updatePaymentMethod = async (storeId, methodId, methodData) => {
  const response = await axios.put(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/payment-methods/${methodId}`, methodData);
  return response.data.data;
};
const deletePaymentMethod = async (storeId, methodId) => {
  await axios.delete(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/payment-methods/${methodId}`);
  return methodId;
};

// Tills (Devices)
const addTill = async (storeId, tillData) => {
  const response = await axios.post(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/tills`, tillData);
  return response.data.data;
};
const updateTill = async (storeId, tillId, tillData) => {
  const response = await axios.put(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/tills/${tillId}`, tillData);
  return response.data.data;
};
const deleteTill = async (storeId, tillId) => {
  await axios.delete(`${API_BASE_URL}${STORES_API_PATH}/${storeId}/tills/${tillId}`);
  return tillId;
};


const storeService = {
  // Core
  getStores,
  getStoreById,
  createStore,
  updateStore,
  deleteStore,
  // Settings
  updateOpeningHours,
  addPaymentMethod,
  updatePaymentMethod,
  deletePaymentMethod,
  addTill,
  updateTill,
  deleteTill,
};

export default storeService;
